const TopAuthorsType = Object.freeze({
  REPLIES: 'Replies',
  REPOSTS: 'Reposts',
  MENTIONS: 'Mentions'
})
export default TopAuthorsType
export type TopAuthorsTypeStrings = typeof TopAuthorsType[keyof typeof TopAuthorsType]
// RESERVE BELOW
